import { ComponentClass } from 'react';
export { ComponentClass };
import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FavoritePdlEditor" */ './lazyIndex')
);

export let lazyCreateNewPdlFavoriteClickedAction = new LazyImport(
    lazyModule,
    m => m.createNewPdlFavoriteClickedAction
);

export let lazyEditFavoritePdlClickedAction = new LazyImport(
    lazyModule,
    m => m.editFavoritePdlClickedAction
);

export const PrivateDistributionlistModalEditor = createLazyComponent(
    lazyModule,
    m => m.PrivateDistributionlistModalEditor
);
